<template>
    <div>
        <b-tabs content-class="mt-3">
            <b-tab title="Minutas" active>
                <app-note-list
                    :supervisor="supervisor"
                    :notes="notes"
                    :the-client-id="!!theClient ? theClient.id : ''"
                />
                <app-pop-up
                    id="note-form-window"
                    title="Ingresar nueva minuta"
                    size="extra-large"
                    :onClose="cleanForm"
                >
                    <div class="form" slot="body">
                        <app-note-form
                            :onSave="onSave"
                            :supervisor="supervisor"
                            :the-client-id="!!theClient ? theClient.id : ''"
                        />
                    </div>
                    <div class="buttons" slot="buttons">
                        <button
                            class="btn btn-confirm"
                            :disabled="inProgress"
                            @click="$bus.$emit('save-note')"
                        >
                            <i class="fa fa-save"></i> Guardar
                        </button>
                    </div>
                </app-pop-up>
            </b-tab>
            <app-pop-up
                id="vehicle-states-form-window"
                title="Novedades Vehiculares"
                :onClose="cleanForm"
            >
                <div class="form" slot="body">
                    <app-vehicle-state-form
                        ref="vehicleStateForm"
                        @disableBtn="onBtnDisable"
                        @enableBtn="onBtnEnable"
                        @saveVehicleState="onsaveVehicleState"
                    ></app-vehicle-state-form>
                </div>
                <div class="buttons" slot="buttons">
                    <button
                        v-if="enableBtn"
                        class="btn btn-confirm"
                        :disabled="inProgress"
                        @click="saveState"
                    >
                        <i class="fa fa-save"></i> Guardar
                    </button>
                </div>
            </app-pop-up>

            <b-tab title="Novedades vehículares">
                <b-row v-if="userCan('create-vehicle-state')">
                    <b-col cols="12" md="4" lg="3">
                        <b-btn
                            :disabled="!client"
                            variant="primary"
                            class="btn-block"
                            @click="
                                $bus.$emit('vehicle-states-form-window.open')
                            "
                        >
                            <i class="fa fa-plus"></i> Crear Novedad Vehicular
                        </b-btn>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-vehicle-state-filters
                            @filter="onFilters"
                            @clearFilters="onfiltered"
                            @client-change="onClientChange"
                        ></app-vehicle-state-filters>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-vehicle-state-list
                            v-if="!!tableData"
                            :table-data="tableData"
                            :on-change-page="onChangePage"
                            @showImage="onShowImage"
                        ></app-vehicle-state-list>
                    </b-col>
                </b-row>
                <!----------------------------- popup imagenes ------------------------------------------>
                <app-pop-up
                    id="vehicle-states-form-images-window"
                    title="Imagenes sobre el estado del vehículo"
                >
                    <div class="form" slot="body">
                        <div v-if="vehicle_state_photos.length > 0">
                            <b-row>
                                <b-col cols="12" md="9" class="py-2">
                                    <b-form-file
                                        placeholder="Agregar imágenes"
                                        v-model="files"
                                        multiple
                                        accept="image/*"
                                    ></b-form-file>
                                </b-col>
                                <b-col cols="12" md="3" class="py-2">
                                    <b-btn
                                        variant="primary"
                                        @click="addImageVehicleState"
                                        :disabled="inProgress"
                                        >Guardar</b-btn
                                    >
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col
                                    cols="12"
                                    md="6"
                                    class="py-2"
                                    v-for="p in vehicle_state_photos"
                                    :key="p.id"
                                >
                                    <a :href="p.photo_url" target="_blank">
                                        <img
                                            width="130"
                                            height="130"
                                            :src="p.photo_url"
                                        />
                                    </a>
                                    <b-btn
                                        variant="danger"
                                        size="sm"
                                        v-if="vehicleStateUserId === user.id"
                                        @click="onDeletePhoto(p.id)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-btn>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else>
                            <b-row>
                                <b-col cols="12" md="9" class="py-2">
                                    <b-form-file
                                        placeholder="Agregar imágenes"
                                        v-model="files"
                                        multiple
                                        accept="image/*"
                                    ></b-form-file>
                                </b-col>
                                <b-col cols="12" md="3" class="py-2">
                                    <b-btn
                                        variant="primary"
                                        @click="addImageVehicleState"
                                        :disabled="inProgress"
                                        >Guardar</b-btn
                                    >
                                </b-col>
                            </b-row>
                            <hr />
                            <p>No hay imágenes.</p>
                        </div>
                    </div>
                </app-pop-up>
                <!---------------------------------- fin popup imagenes ------------------>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import NoteList from './NoteList.vue'
import NoteForm from './NoteForm.vue'
import VehicleStateForm from '../../VehiclesReview/VehicleStateForm'
import VehicleStateFilters from '../../VehiclesReview/VehicleStateFilters'
import VehicleStateList from '../../VehiclesReview/VehicleStateList'
export default {
    components: {
        appNoteList: NoteList,
        appNoteForm: NoteForm,
        appVehicleStateForm: VehicleStateForm,
        appVehicleStateFilters: VehicleStateFilters,
        appVehicleStateList: VehicleStateList,
    },
    props: {
        theClient: {
            type: Object,
        },
        supervisor: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            notes: [],
            note: {
                content: '',
                annotationTypeId: '',
                withNews: false,
            },
            enableBtn: true,
            filters: '',
            page: 1,
            sortBy: 'vehicle_states.created_at',
            sortDir: 'DESC',
            tableData: '',
            tableDataOriginal: '',
            vehicle_state_photos: [],
            vehicleStateUserId: '',
            files: [],
            vehicleStateId: '',
        }
    },
    methods: {
        onClientChange(client) {
            this.$store.commit('client', client)
            this.loadVehicleStates()
            this.$refs['vehicleStateForm'].loadServiceSpots()
        },
        onSave() {
            this.$bus.$emit('note-form-window.close')
        },
        onsaveVehicleState() {
            this.$bus.$emit('vehicle-states-form-window.close')
            this.loadVehicleStates()
        },
        cleanForm() {
            this.$bus.$emit('note-form-basic.clean')
            this.$bus.$emit('note-form-news.clean')
            this.$bus.$emit('note-form.clean')
        },
        saveState() {
            this.$refs.vehicleStateForm.saveVehicleState()
            this.loadVehicleStates()
        },
        async addImageVehicleState() {
            if (this.files.length) {
                const formData = new FormData()
                formData.append('vehicleStateId', this.vehicleStateId)
                this.files.map(item => formData.append('files[]', item))

                const { data } = await repo.post(
                    'vehicle-states/files',
                    formData
                )
                if (data.status) {
                    toastr.success('Imagen registrada correctamente')
                    this.$bus.$emit('vehicle-states-form-images-window.close')
                    this.loadVehicleStates()
                    this.files = []
                } else {
                    toastr.error(data.msg)
                }
            } else {
                toastr.error('No hay ningun archivo seleccionado')
            }
        },
        onBtnDisable() {
            this.enableBtn = false
        },
        onBtnEnable() {
            this.enableBtn = true
        },
        onFilters(filters) {
            this.filters = filters
            this.loadVehicleStates()
        },
        onShowImage(vehicleState) {
            this.$bus.$emit('vehicle-states-form-images-window.open')
            this.vehicle_state_photos = vehicleState.vehicle_state_photos
            this.vehicleStateUserId = vehicleState.user_id
            this.vehicleStateId = vehicleState.id
        },
        async onDeletePhoto(id) {
            const { data } = await repo.delete(`vehicle-states/files/${id}`)
            if (data.status) {
                toastr.success(data.msg)
                this.loadVehicleStates()
                this.$bus.$emit('vehicle-states-form-images-window.close')
            }
        },
        async loadVehicleStates() {
            if (!this.client) return
            try {
                const params = {
                    ...this.filters,
                    page: this.page,
                    sortDir: this.sortDir,
                    sortBy: this.sortBy,
                }

                if (!!this.client) {
                    params['clientId'] = this.client.id
                }

                if (this.user.profile.client_side && !!this.accessPoint) {
                    params['venueId'] = this.accessPoint.venue_id
                }

                const { data } = await repo.get('vehicle-states', params)
                this.tableData = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onfiltered() {
            this.loadVehicleStates()
        },
        openFormVehicleState() {
            this.$bus.$emit('vehicle-states-form-window.open')
        },
        onChangePage(page) {
            this.page = page
            this.loadVehicleStates()
        },
    },
    mounted() {
        this.loadVehicleStates()
    },
}
</script>
